import { Dispatch, FC, MutableRefObject, SetStateAction } from 'react';

import { ScrollState } from '../../hooks/useScrollArea';

import ScrollArea from '../scrollArea';
import { TIMESLOT_STEP } from '../../constants/timeslot';

interface Props {
  horizontal: boolean;
  scrollRef?: MutableRefObject<{}>;
  scrollState?: ScrollState;
  setScrollState?: Dispatch<SetStateAction<ScrollState>>;
  scrollToPosition?: () => null;
}

const ScrollWrapper: FC<Props> = ({
  horizontal = true,
  scrollRef,
  scrollState,
  setScrollState,
  scrollToPosition,
  children,
}) => {
  const canScrollBackward = () => {
    const { x = 0, y = 0 } = scrollState;
    return horizontal ? x > 0 : y > 0;
  };

  const canScrollForward = () => {
    const { x = 0, y = 0, maxX = 0, maxY = 0 } = scrollState;
    return horizontal ? x < maxX : y < maxY;
  };

  const handleBackwardClick = () => scrollToPosition(TIMESLOT_STEP * -2, true);
  const handleForwardClick = () => scrollToPosition(TIMESLOT_STEP * 2, true);

  return (
    <div
      className="timeslot-widget timeslot-widget__horizontal hours"
      data-testid="timeslotContainer"
    >
      <button
        className="timeslot-widget__button timeslot-widget__button--backward"
        onClick={handleBackwardClick}
        disabled={!canScrollBackward()}
      >
        <i className="fas fa-caret-left" />
      </button>

      <ScrollArea
        className="timeslot-widget__inner"
        scrollbars={false}
        state={scrollState}
        setState={setScrollState}
        horizontal
        ref={scrollRef}
      >
        <div className="timeslot-widget__content">{children}</div>
      </ScrollArea>

      <button
        className="timeslot-widget__button timeslot-widget__button--forward"
        onClick={handleForwardClick}
        disabled={!canScrollForward()}
      >
        <i className="fas fa-caret-right" />
      </button>
    </div>
  );
};

export default ScrollWrapper;
